import { register } from '../apiRegistry';
import { apiService} from '../apiService';
const getStudentId = () => localStorage.getItem('studentId');

const engageItems = [
  {
    contentName: 'JO - Become an AI Powered Professional (Shreyas).mp4',
    contentUrl: 'https://lms.content.umsglobal.net/23913707758919/230297/17060/1.0~ccaa466e-6651-4a4a-b39c-7fb3d7367209',
    extension: 'mp4'
  },
  {
    contentName: 'JO - MBA in 2025 Still Worth (Sushant).mp4',
    contentUrl: 'https://lms.content.umsglobal.net/23913707758919/230297/17061/1.0~41da4dd8-a806-4cdd-9285-9150210b06a6',
    extension: 'mp4'
  },
  {
    contentName: 'JO - AI Applications in Data Analytics (Tanoy Dewanjee).mp4',
    contentUrl: 'https://lms.content.umsglobal.net/23913707758919/230297/17062/1.0~219edade-8034-4127-ba78-53a3525fcacf',
    extension: 'mp4'
  },
  {
    contentName: 'JO - Generative AI for Marketing (Karan Rana).mp4',
    contentUrl: 'https://lms.content.umsglobal.net/23913707758919/230297/17063/1.0~882ca335-a5e6-4c95-87fe-05294e5ad51f',
    extension: 'mp4'
  },
  {
    contentName: 'JO - Supercharge your ad campaigns using AI (Sumit Verma).mp4',
    contentUrl: 'https://lms.content.umsglobal.net/23913707758919/230297/17064/1.0~65c049ee-51c4-4a3c-88d4-84414c24a4a4',
    extension: 'mp4'
  },
  {
    contentName: 'JO - Your Complete guide to AI Chatbots (Ravi Prakash).mp4',
    contentUrl: 'https://lms.content.umsglobal.net/23913707758919/230297/17065/1.0~47292934-ce02-4174-b65c-706740758fbb',
    extension: 'mp4'
  }
];
register({
  'user/profile': async () => {
    return await apiService.get('student-profile');
  },
  'user/engage': async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return engageItems;
  }
});
